import { FC } from 'react';

import Attribution from './attribution';
import Details from './details';
import UniversalFilter from './filter';
import { IAttributionItem, IDetailItem } from '../../../../app/types/filter';
import { getCookie } from '../../../../helpers/utils/cookies';
import { useTypedSelector } from '../../../../shared/common/hooks/useTypedSelector';


interface IParamsProps {
    withAttribution?: boolean;
    attributionItems?: IAttributionItem[];
    withDetails?: boolean;
    detailsItems?: IDetailItem[];
    withCompare?: boolean;
    withSegments?: boolean;
    filtersFilter?: string[];
    isFilterVisible?: boolean
    isDashboard?: boolean;
    isModalDashboard?: boolean;
    setUpdateDashboard?: () => void;
}

const Params: FC<IParamsProps> = ({
    withAttribution = true,
    attributionItems,
    withDetails = true,
    detailsItems,
    withSegments = true,
    filtersFilter,
    isFilterVisible = true,
    isModalDashboard,
    isDashboard,
    setUpdateDashboard,
}) => {
    const { isCompare, isNotParamsFilterVisible } = useTypedSelector((state) => state.meta);
    const isNumberDisplay = getCookie('chosenDisplay') === 'number';
    const isChartDisplay = getCookie('chosenDisplay') === 'chart';

    // Для модального окна — всё в одну строку как в отчётах
    return (
        <div
            style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: '8px',
            }}
        >
            {withAttribution && attributionItems && (
                <Attribution items={attributionItems} isDashboard={isDashboard} isModalDashboard={isModalDashboard} />
            )}
            {withDetails && detailsItems && !isNumberDisplay && isChartDisplay && <Details items={detailsItems} />}
            {(!isNotParamsFilterVisible || !isFilterVisible) && (
                <UniversalFilter
                    isCompare={isCompare}
                    withSegment={withSegments}
                    filtersFilter={filtersFilter}
                    isModal={isModalDashboard}
                    setUpdateDashboard={setUpdateDashboard}
                />
            )}
        </div>
    );
};

export default Params;